import React from 'react';
import { useNavigate } from "react-router-dom";
import Button from '../Button';

const BackButton = ({buttonSize = "h-5 w-5 max-w-5 max-h-5"}) => {
    const navigate = useNavigate();
    return <Button buttonColor='bg-white' classNames={`p-3 flex ${buttonSize}`} onClickAction={() => navigate(`/app`)} iconName={"back.svg"} tIconName={"arrow-narrow-left"}/>
}

export default BackButton